import { render, staticRenderFns } from "./RankAndReward.vue?vue&type=template&id=50f9cd24&scoped=true&"
import script from "./RankAndReward.vue?vue&type=script&lang=js&"
export * from "./RankAndReward.vue?vue&type=script&lang=js&"
import style0 from "./RankAndReward.vue?vue&type=style&index=0&id=50f9cd24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9cd24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f9cd24')) {
      api.createRecord('50f9cd24', component.options)
    } else {
      api.reload('50f9cd24', component.options)
    }
    module.hot.accept("./RankAndReward.vue?vue&type=template&id=50f9cd24&scoped=true&", function () {
      api.rerender('50f9cd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaderboard/campaign/components/RankAndReward.vue"
export default component.exports